import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { LogEffects } from './log.effects';
import { LogFacade } from './log.facade';

@NgModule({
    declarations: [],
    imports: [EffectsModule.forFeature([LogEffects])],
    providers: [LogFacade],
})
export class LogStoreModule {}
